import { z } from 'zod';
import { SubscriptionSaleType } from './subscriptionSaleType.js';
export const saleFromRegistrationBlockerSchema = z.enum(['HoldsSubscription', 'NoSalePermitted', 'Migration']);
export const SaleFromRegistrationBlocker = saleFromRegistrationBlockerSchema.enum;
export const findSaleFromRegistrationBlocker = ({ holdsSubscription, eligibility, }) => {
    if (holdsSubscription) {
        return SaleFromRegistrationBlocker.HoldsSubscription;
    }
    const { recommended } = eligibility;
    if (!recommended) {
        return SaleFromRegistrationBlocker.NoSalePermitted;
    }
    return recommended === SubscriptionSaleType.Migration ? SaleFromRegistrationBlocker.Migration : undefined;
};
